/* src/app/shared/components/result-total/result-total.component.scss */
:root {
  --cf-brand: #e3fd64;
  --cf-brand-dark: #4d7a00;
  --cf-brand-light: #f9ffe0;
  --cf-chrome: #1d2530;
  --cf-bg: #f4f6f8;
  --cf-surface: #ffffff;
  --cf-surface-hover: #f9fafc;
  --cf-text: #1a1d23;
  --cf-text-muted: #6b7280;
  --cf-text-on-dark: rgba(255, 255, 255, 0.87);
  --cf-border: #e5e7eb;
  --cf-border-strong: #d1d5db;
  --cf-radius: 8px;
  --cf-radius-sm: 4px;
  --cf-radius-lg: 12px;
  --cf-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
  --cf-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --cf-success: #16a34a;
  --cf-warning: #d97706;
  --cf-error: #dc2626;
}
.totals-container {
  display: flex;
  gap: 1rem;
  padding: 1rem 0;
  flex-wrap: nowrap;
  margin-left: 1.5rem;
  overflow-x: auto;
}
.total-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 0.8rem 1.4rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
  min-width: 140px;
  text-align: center;
  border: 1px solid #f0f0f0;
}
.title {
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 0.4rem;
}
.value {
  font-weight: 700;
  font-size: 1.2rem;
  color: #111;
}
.value.green {
  color: #28a745 !important;
}
.value.orange {
  color: #f0a329 !important;
}
/*# sourceMappingURL=result-total.component.css.map */
